// Frontend logger - отключается в production
const isDevelopment = import.meta.env.MODE === 'development';

const noop = () => {};

export const logger = {
  log: isDevelopment ? console.log.bind(console) : noop,
  info: isDevelopment ? console.info.bind(console) : noop,
  warn: isDevelopment ? console.warn.bind(console) : noop,
  // error всегда работает - ошибки важны даже в production
  error: console.error.bind(console),
  debug: isDevelopment ? console.debug.bind(console) : noop,
};

export default logger;
